"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.round = exports.ternarySearchMax = exports.ternarySearchMin = exports.cubicBezierDeriv = exports.cubicBezier = exports.quadraticBezierDeriv = exports.quadraticBezier = exports.normalize = exports.hypot = void 0;
// eslint-disable-next-line @typescript-eslint/unbound-method
exports.hypot = Math.hypot || (function (x, y) { return Math.sqrt(x * x + y * y); });
/** Calculates a new vector with the same angle and a new magnitude. */
function normalize(_a, magnitude) {
    var x = _a[0], y = _a[1];
    if (magnitude === void 0) { magnitude = 1; }
    if (x === 0 && y === 0) {
        // Angle is the same as Math.atan2(y, x)
        return [1 / x === Infinity ? magnitude : -magnitude, 0];
    }
    var k = magnitude / exports.hypot(x, y);
    return [x * k, y * k];
}
exports.normalize = normalize;
function quadraticBezier(p1, p2, p3, t) {
    var s = 1 - t;
    return (s * s) * p1 + 2 * (s * t) * p2 + (t * t) * p3;
}
exports.quadraticBezier = quadraticBezier;
/** Returns d/dt(quadraticBezier) */
function quadraticBezierDeriv(p1, p2, p3, t) {
    // const s = 1 - t;
    // ds/dt = -1
    // return (-2 * s) * p1 + 2 * (s - t) * p2 + (2 * t) * p3;
    return 2 * (t * (p1 - 2 * p2 + p3) - p1 + p2);
}
exports.quadraticBezierDeriv = quadraticBezierDeriv;
function cubicBezier(p1, p2, p3, p4, t) {
    var s = 1 - t;
    return (s * s * s) * p1 + 3 * (s * s * t) * p2 + 3 * (s * t * t) * p3 + (t * t * t) * p4;
}
exports.cubicBezier = cubicBezier;
/** Returns d/dt(cubicBezier) */
function cubicBezierDeriv(p1, p2, p3, p4, t) {
    // const s = 1 - t;
    // ds/dt = -1
    // const ss = s * s;
    // const st = s * t;
    // const tt = t * t;
    // return (-3 * ss) * p1 + 3 * (ss - 2 * st) * p2 + 3 * (2 * st - tt) * p3 + (3 * tt) * p4;
    return 3 * (t * (t * (-p1 + 3 * p2 - 3 * p3 + p4) + 2 * (p1 - 2 * p2 + p3)) - p1 + p2);
}
exports.cubicBezierDeriv = cubicBezierDeriv;
/** Find the minimum of a function by ternary search. */
function ternarySearchMin(func, left, right, eps) {
    if (eps === void 0) { eps = 1E-5; }
    while (left + eps < right) {
        var x1 = left + (right - left) / 3;
        var x2 = right - (right - left) / 3;
        var y1 = func(x1);
        var y2 = func(x2);
        if (y1 < y2) {
            right = x2;
        }
        else {
            left = x1;
        }
    }
    return left + (right - left) / 2;
}
exports.ternarySearchMin = ternarySearchMin;
/** Find the maximum of a function by ternary search. */
function ternarySearchMax(func, left, right, eps) {
    return ternarySearchMin(function (x) { return -func(x); }, left, right, eps);
}
exports.ternarySearchMax = ternarySearchMax;
function round(v, rate) {
    if (rate === void 0) { rate = 1E8; }
    return Math.round(v * rate) / rate;
}
exports.round = round;
